import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWondaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1122 320",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M158.11 0H131.759V11.8373H158.11V0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.457 0H263.519V11.8373H296.457V0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.275 11.8348H125.161V23.6721H171.275V11.8348Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.389 11.8348H210.801V23.6721H217.389V11.8348Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.024 11.8348H250.323V23.6721H303.024V11.8348Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.761 23.6753H118.586V35.5126H131.761V23.6753Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M263.51 23.6753H158.107V35.5126H263.51V23.6753Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.617 23.6753H296.442V35.5126H309.617V23.6753Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.761 35.5126H118.586V47.3475H131.761V35.5126Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.807 35.5102H171.28V47.3475H210.807V35.5102Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.338 35.5102H217.4V47.3475H250.338V35.5102Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.617 35.5126H296.442V47.3475H309.617V35.5126Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.163 47.3507H111.988V59.188H125.163V47.3507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M184.466 47.3507H177.879V59.188H184.466V47.3507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.619 47.3507H283.268V59.188H309.619V47.3507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.163 59.188H111.988V71.0228H125.163V59.188Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.384 59.1855H164.682V71.0228H217.384V59.1855Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.449 59.1855H243.747V71.0228H296.449V59.1855Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.215 59.1855H303.04V71.0228H316.215V59.1855Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.589 71.026H92.2384V82.8633H118.589V71.026Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.282 71.026H158.107V82.8633H171.282V71.026Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.977 71.026H210.801V82.8633H223.977V71.026Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.324 71.026H237.149V82.8633H250.324V71.026Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322.805 71.026H289.866V82.8633H322.805V71.026Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.982 82.8609H65.8684V94.6982H111.982V82.8609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.272 82.8609H151.509V94.6982H171.272V82.8609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.63 82.8609H184.454V94.6982H197.63V82.8609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.977 82.8633H210.801V94.6982H223.977V82.8633Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.324 82.8633H237.149V94.6982H250.324V82.8633Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.694 82.8609H263.519V94.6982H276.694V82.8609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.392 82.8609L289.866 82.8633V94.6982H329.392V82.8609Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.2332 94.6957H46.1192V106.533H92.2332V94.6957Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.284 94.6957H144.933V106.533H171.284V94.6957Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.229 94.6957H177.879V106.533H204.229V94.6957Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.977 94.6982H210.801V106.533H223.977V94.6982Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.324 94.6982H237.149V106.533H250.324V94.6982Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M283.272 94.6957H256.921V106.533H283.272V94.6957Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.042 94.6957L289.866 94.6982V106.533H303.042V94.6957Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.379 94.6957H309.615V106.533H329.379V94.6957Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.8841 106.536H32.9455V118.374H65.8841V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.284 106.536H144.933V118.374H171.284V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.63 106.536H184.454V118.374H197.63V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.977 106.536H210.801V118.374H223.977V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.324 106.536H237.149V118.374H250.324V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.694 106.536H263.519V118.374H276.694V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.392 106.536H289.866V118.374H329.392V106.536Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.1105 118.371H26.3474V130.208H46.1105V118.371Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.272 118.371H151.509V130.208H171.272V118.371Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.977 118.374H210.801V130.208H223.977V118.374Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M250.324 118.374H237.149V130.208H250.324V118.374Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.629 118.371L289.866 118.374V130.208H309.629V118.371Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.389 118.371H316.214V130.208H329.389V118.371Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9368 130.212H13.1737V142.049H32.9368V130.212Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.384 130.212H164.682V142.049H217.384V130.212Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.449 130.212H243.747V142.049H296.449V130.212Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M329.389 130.212H316.214V142.049H329.389V130.212Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.3491 142.046L13.1737 142.049V153.884H26.3491V142.046Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.858 142.046L164.682 142.049V153.884H177.858V142.046Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.454 142.046H289.866V153.884H296.454V142.046Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M322.791 142.046H309.615V153.884H322.791V142.046Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7736 153.887H6.59814V165.724H19.7736V153.887Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M316.215 153.887H303.04V165.724H316.215V153.887Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 165.62H0V177.457H13.1754V165.62Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M309.617 165.62H296.442V177.457H309.617V165.62Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 177.562H0V189.4H13.1754V177.562Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.042 177.562H289.866V189.4H303.042V177.562Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 189.4H0V201.234H13.1754V189.4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.443 189.397H283.268V201.234H296.443V189.397Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 201.13H0V212.968H13.1754V201.13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M184.459 201.13H144.933V212.968H184.459V201.13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.042 201.13H289.866V212.968H303.042V201.13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 213.072H0V224.91H13.1754V213.072Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.761 213.072H118.586V224.91H131.761V213.072Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.624 213.072H138.335V224.91H197.624V213.072Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.042 213.072H289.866V224.91H303.042V213.072Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 224.806H0V236.643H13.1754V224.806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.926 224.806H111.988V236.643H144.926V224.806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.217 224.806H184.454V236.643H204.217V224.806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M303.042 224.806H289.866V236.643H303.042V224.806Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1754 236.748H0V248.585H13.1754V236.748Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.587 236.748H105.412V248.585H118.587V236.748Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.049 236.748H131.759V248.585H191.049V236.748Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.803 236.748H197.628V248.585H210.803V236.748Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.443 236.748H283.268V248.585H296.443V236.748Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7736 248.583H6.59814V260.42H19.7736V248.583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M138.338 248.583H111.988V260.42H138.338V248.583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.635 248.583H144.933V260.42H197.635V248.583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.401 248.583H204.226V260.42H217.401V248.583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M296.456 248.583H276.692V260.42H296.456V248.583Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9368 260.316H13.1737V272.153H32.9368V260.316Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M131.761 260.316H118.586V272.153H131.761V260.316Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.63 260.316H184.454V272.153H197.63V260.316Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M217.401 260.316H204.226V272.153H217.401V260.316Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M283.272 260.316H256.921V272.153H283.272V260.316Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.1227 272.258H19.7718V284.095H46.1227V272.258Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.642 272.258H177.879V284.095H197.642V272.258Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.691 272.258H204.226V284.095H276.691V272.258Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.4718 283.991H32.9455V295.828H72.4718V283.991Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M197.621 283.991H164.682V295.828H197.621V283.991Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M256.928 283.991H204.226V295.828H256.928V283.991Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.874 295.832H46.1192V307.669H177.874V295.832Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.695 307.768H72.4665V319.605H164.695V307.768Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M440.37 233.803V214.419H420.391V85.8027H449.225V202.789H460.349V163.565H480.556V105.414H509.39V163.565H529.596V202.789H540.948V85.8027H569.555V214.419H549.803V233.803H520.742V214.419H500.535V175.196H489.41V214.419H469.204V233.803H440.37Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M610.427 233.803V214.419H590.448V144.41H610.427V124.798H679.447V144.41H699.654V214.419H679.447V233.803H610.427ZM619.282 202.789H670.593V155.812H619.282V202.789Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M727.248 233.803V124.798H816.247V144.41H836.453V233.803H807.392V155.812H756.082V233.803H727.248Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M879.593 233.803V214.419H859.613V144.41H879.593V124.798H939.985V85.8027H969.046V214.419H948.612V233.803H879.593ZM888.447 202.789H939.758V155.812H888.447V202.789Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1011.96 233.803V214.419H991.979V144.41H1011.96V124.798H1080.98V144.41H1101.18V202.789H1121.39V233.803H1092.33V214.419H1080.98V233.803H1011.96ZM1020.81 202.789H1072.12V155.812H1020.81V202.789Z",
			fill: "currentColor"
		})
	]
});
export default SvgWondaLogo;
